import { createLazyComponent, LazyModule } from 'owa-bundling';
var lazyModule = new LazyModule(function () {
    return System.import(/* webpackChunkName: "LostFocusAlert" */ './lazyIndex');
});
var LostFocusAlert = createLazyComponent(lazyModule, function (m) { return m.LostFocusAlert; });
export { // ComponentClass has to to be exported since it is the type of LostFocusAlert
LostFocusAlert, };
//# sourceMappingURL=index.js.map